import React from 'react';
import classNames from 'classnames';

const baseString = 'vra-list';

interface ListProps {
  childClassName?: string;
  children: React.ReactNode[];
  className?: string;
  name: string;
  testId?: string;
}

const List = ({
  childClassName,
  children,
  className,
  name,
  testId,
}: ListProps) => {
  const classString = classNames({
    [`${baseString}`]: true,
    [`${className}`]: !!className
  });

  const items = children.map((child, index) => {
    const itemClassString = classNames({
      [`${baseString}__item`]: true,
      [childClassName]: !!childClassName
    });

    return (
      <li
        className={itemClassString}
        key={`${name}-list-item-${index}`}>
        {child}
      </li>
    );
  });

  return (
    <ul className={classString} data-test-id={testId}>
      {items}
    </ul>
  );
};

export default List;
